import React, { useState } from 'react';
import { Box, Image, Text } from '@chakra-ui/react';
import './FlipCard.css';

const FlipCard = ({ frontImage, backImage, frontText, backText }) => {
    const [flipped, setFlipped] = useState(false);

    const handleFlip = () => {
        setFlipped(!flipped);
    };

    return (
        <Box className={`flipping-card ${flipped ? 'flipped' : ''}`} onClick={handleFlip}>
            <Box className="flipping-card-inner">
                <Box className="flipping-card-front">
                    <Image src={frontImage} alt={frontText} borderRadius="2xl" className="flipping-card-image" />
                </Box>
                <Box className="flipping-card-back">
                    <Image src={backImage} alt={backText} borderRadius="lg" className="flipping-card-back-image" />
                    <Text fontSize="sm" color="gray.700">{backText}</Text>
                </Box>
            </Box>
        </Box>
    );
};

export default FlipCard;
